


















































































































































































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import {
  ref,
  onMounted,
  watch,
  defineComponent,
  SetupContext,
  PropType,
  computed,
  useRoute,
  useStore,
  nextTick,
} from '@nuxtjs/composition-api'
import { set } from '@vue/composition-api'
import { validators, textErrors } from '@/validation'
import InputText from '@/components/Inputs/InputText.vue'
import InputSelect from '@/components/Inputs/InputSelect.vue'
import InputTextArea from '@/components/Inputs/InputTextarea.vue'
import InputCheckbox from '@/components/Inputs/InputCheckbox.vue'
import InputDate from '@/components/Inputs/InputDate.vue'
import InputAccept from '@/components/Inputs/InputAccept.vue'
import InputOfficeMap from '@/components/Inputs/InputOfficeMap.vue'
import InputRegion from '@/components/Inputs/InputRegion.vue'
import InputCity from '@/components/Inputs/InputCity.vue'
import InputFile from '@/components/Inputs/InputFile.vue'
import InputFileMultiple from '@/components/Inputs/InputFileMultiple.vue'
import InputSelectRegion from '@/components/Inputs/InputSelectRegion.vue'
import BlockTagRow from '@/components/Tags/BlockTagRow.vue'
import Link from '@/components/Link.vue'
import { isNotDefined } from '@/packages/basis/scripts/defineHelpers'
import { FormInputBasic } from '@/contracts/FormInput'
import SmartCaptcha from '@/components/Inputs/new-design/SmartCaptcha.vue'

import {
  IFormContactBlock,
  emptyFormContactBlock,
} from '@/contracts/IFormContactBlock'
import BlockProgressionSelect from '@/components/BlockProgressionSelect.vue'
import BlockNearestOffice from '@/components/FormInput/BlockNearestOffice.vue'
import BlockSelectAuto from '@/components/BlockSelectAuto.vue'
import BlockMultiFields from '@/components/BlockMultiFields.vue'
import { validateOnBlurInputFieldTypes } from '@/forms-data/constants'

@Component
class FormGenerator extends Vue {
  @Prop() readonly forms: ReadonlyArray<any> = []
  @Prop({
    default: () => {},
  })
  readonly initialModel: { [key: string]: any }

  @Prop({
    default: () => {},
  })
  readonly block: { [key: string]: any }

  // массив всех вышестоящий v-model в порядке убывания вложенности
  @Prop({ default: () => [] }) readonly parentsModel: any[]
  @Prop({ default: 'off' }) readonly autocomplete: string = ''
  @Prop() readonly formTitle: string = ''
  @Prop() readonly formTitleEng: string = ''
  @Prop() readonly privacyTitle: string = ''
  @Prop() readonly privacyLinkUrl: string = ''
  @Prop() readonly privacyLinkLabel: string = ''
  @Prop() readonly policyAccept: string = ''
  @Prop() readonly sendButtonText: string = ''
  @Prop() readonly sendButtonTextEng: string = ''
  @Prop() readonly switchLangLink: string = ''
  @Prop() readonly switchLangLinkEng: string = ''
  @Prop() readonly switchLangLinkText: string = ''
  @Prop() readonly switchLangLinkTextEng: string = ''

  @Prop() readonly typeCaptcha: string = ''
  @Prop() readonly formDescription: string = ''
  @Prop() readonly btnLabel: string = ''
  @Prop() readonly memoText: string = ''
  @Prop() readonly disableBtn: boolean = false
  @Prop() readonly isFormSend: boolean = true
  @Prop() readonly isDarkTheme: boolean = true
  @Prop({ default: 'ru' }) readonly lang: string = ''

  @Prop() readonly isNewStyle: boolean = false
  @Prop() readonly formType: string = ''
  @Prop() readonly hasCaptcha: boolean = false
  @Prop({ default: false }) readonly isMemoText: boolean = false
  @Prop({ default: false }) readonly isNoButton: boolean = false
  @Prop() readonly contacts: IFormContactBlock = emptyFormContactBlock()
  @Prop({ default: true }) readonly useValidateOnBlur: boolean = true
  static options: any
}

export default defineComponent({
  name: 'FormGenerator',
  components: {
    InputText,
    Link,
    InputOfficeMap,
    InputCheckbox,
    SmartCaptcha,
    InputAccept,
    InputSelect,
    InputDate,
    InputRegion,
    InputCity,
    InputTextArea,
    InputFile,
    InputFileMultiple,
    BlockTagRow,
    InputSelectRegion,
    BlockProgressionSelect,
    BlockNearestOffice,
    BlockSelectAuto,
    BlockMultiFields,
  },
  props: FormGenerator.options.props,

  setup(
    props: FormGenerator.options.props,
    { refs, emit, root }: SetupContext
  ) {
    const store = useStore()
    const route = useRoute()
    const region = computed(() => store.getters['region/getRegion'])
    const isInitedMap = computed(() => store.getters['settings/getMapIsInit'])
    const isFormSend = ref<PropType<boolean>>(props.isFormSend)
    const model = ref<any>({})
    const errors = ref<any[]>([])
    const showError = ref<boolean>(false)
    const tel = ref(0)
    const isInvalidForm = ref<boolean>(false)
    const validationCounter = ref<number>(0)
    const showCaptcha = ref(false)

    const clear = (id) => {
      model.value[id] = null
    }

    const formsList = computed(() => {
      return Array.isArray(props.forms) ? props.forms : []
    })

    const btnText = computed(() => {
      if (props.sendButtonText || props.sendButtonTextEng) {
        return props.lang === 'ru'
          ? props.sendButtonText
          : props.sendButtonTextEng
      }
      return props.btnLabel
    })

    const switchLinkText = computed(() => {
      return props.formType === 'studentDmsEng'
        ? props.switchLangLinkText
        : props.switchLangLinkTextEng
    })

    const switchLink = computed(() => {
      return props.formType === 'studentDmsEng'
        ? props.switchLangLink
        : props.switchLangLinkEng
    })

    // Если вернёт true то ошибки есть
    const checkErrors = async () => {
      let index = 0
      validationCounter.value += 1
      for (const form: FormInputBasic of formsList.value) {
        if (!form.showIf || form.showIf(model.value, ...props.parentsModel)) {
          await checkItemErrors(form, index)
        } else {
          set(errors.value, index, false)
        }
        index++
      }
      return !!errors.value.find((item) => item)
    }

    const blockShowif = computed(() => {
      return (
        !props?.block?.showIf ||
        props?.block?.showIf(model.value, ...props.parentsModel)
      )
    })
    const formattedRegion = (region: string) => {
      if (region.includes('область')) {
        return region.replace('область', 'обл')
      } else if (
        !region.includes('область') &&
        !region.includes('край') &&
        !region.toLowerCase().includes('республика')
      ) {
        return `г ${region}`
      } else {
        return region
      }
    }
    const onChange = (
      val: any,
      name: any,
      index: string | number,
      isGroup = false
    ) => {
      if (
        val &&
        name === 'userOffice' &&
        route.value.path.includes('about/career/stat-agentom') &&
        isInitedMap.value
      ) {
        const myReverseGeocoder = ymaps.geocode([
          val.value.coords[0],
          val.value.coords[1],
        ])
        myReverseGeocoder.then(function (res) {
          const firstGeoObject = res.geoObjects.get(0)

          root.$set(model.value, 'userCity', {
            postalCode: null,
            region: formattedRegion(firstGeoObject.getAdministrativeAreas()[0]),
            regionId: null,
            regionWithType: formattedRegion(
              firstGeoObject.getAdministrativeAreas()[0]
            ),
            city: null,
            cityKladrId: null,
            kladr_id: null,
            street: null,
            streetWithType: null,
            houseType: null,
            house: null,
            block: null,
            flatType: null,
            flat: null,
            address: formattedRegion(
              firstGeoObject.getAdministrativeAreas()[0]
            ),
            district: null,
            regionText: formattedRegion(
              firstGeoObject.getAdministrativeAreas()[0]
            ),
            cityText: null,
            region_kladr_id: null,
            settlement_kladr_id: null,
            excludeError: false,
          })
          const userCityRef = refs['field-userCity-4'][0].$refs.vuedadata as any
          userCityRef.setInputQuery(
            formattedRegion(firstGeoObject.getAdministrativeAreas()[0])
          )
          userCityRef.query = formattedRegion(
            firstGeoObject.getAdministrativeAreas()[0]
          )
          if (region?.value !== model.value?.userCity.regionWithType) {
            store.commit(
              'region/SET_REGION',
              formattedRegion(firstGeoObject.getAdministrativeAreas()[0])
            )
          }
          const field = formsList.value.find(
            (form: FormInputBasic) => form.id === 'userCity'
          )
          checkItemErrors(field, formsList.value.indexOf(field))
          showError.value = true
        })
      }

      // FIXME понять в чём разница с FormGenerator и синхронизироваться логику. Строка 369
      if (val && val.linkText) {
        root.$set(model.value, name, val.id || null)
      } else if (isGroup && !model.value[name]) {
        root.$set(model.value, name, [val])
      } else if (isGroup && model.value[name]) {
        if (model.value[name].includes(val)) {
          const groupField = model.value[name].filter(
            (groupVal) => groupVal !== val
          )
          root.$set(model.value, name, groupField)
        } else {
          const groupField = [...model.value[name], val]
          root.$set(model.value, name, groupField)
        }
        if (!model.value[name].length) {
          root.$set(model.value, name, null)
        }
      } else {
        root.$set(model.value, name, val || null)
      }

      emit('change', model.value)

      const field = formsList.value.find(
        (form: FormInputBasic) => form.id === name
      )
      if (
        !validateOnBlurInputFieldTypes.includes(field.field) ||
        !props.useValidateOnBlur
      ) {
        checkItemErrors(field, index)
        showError.value = true
      }
      setTel(val, name)
    }
    const setTel = (val: any, name: any) => {
      if (name === 'userTel') {
        tel.value = ref(val)
      }
    }
    // Валидация поля (Инпуты, селекты, итд)
    const checkItemErrors = async (field, index) => {
      if (
        isNotDefined(field.rules) ||
        !Array.isArray(field.rules) ||
        field.rules.length === 0
      ) {
        return false
      }

      let error = false
      for (const rule: any of field.rules) {
        const isFunctionalRule = typeof rule === 'function'
        const isRuleExist = isFunctionalRule
          ? rule(model.value, ...props.parentsModel)
          : rule in validators
        const isMultipleFields = field.field === 'BlockMultiFields'
        let errorLocal = false
        const component = refs[`field-${field.id}-${index}`]
        if (isMultipleFields && component) {
          errorLocal = await component[0].checkErrors(showError.value)
        } else if (isFunctionalRule) {
          errorLocal =
            isRuleExist &&
            validators[isRuleExist](model.value[field.id], field[isRuleExist])
        } else {
          const validValue =
            typeof (field as any)[rule] === 'function'
              ? (field as any)[rule](model.value, ...props.parentsModel)
              : (field as any)[rule]
          errorLocal =
            isRuleExist &&
            (await (validators as any)[rule](
              (model.value as any)[field.id],
              validValue
            ))
        }
        if (errorLocal) error = errorLocal
      }
      set(errors.value, index, error)
    }

    const submitPrevent = async (showErrorStatus = null) => {
      const isError = await checkErrors()
      if (isInvalidForm.value) {
        showError.value = showErrorStatus ?? true
      } else if (props.hasCaptcha) {
        showCaptcha.value = true
        await nextTick()
        if (refs.smartCaptcha && props.typeCaptcha === 'yandex') {
          refs.smartCaptcha.reset()
          refs.smartCaptcha.execute()
          emit('submit-captcha', model.value)
        }
      } else {
        emit('submit', model.value)
        emit('userTel', tel.value)
      }
      return isError
    }

    watch(isFormSend, () => {
      refs.form.reset()
    })

    watch(
      errors,
      (errorsList) => {
        isInvalidForm.value = !!errorsList.find((item) => item)
      },
      { immediate: true, deep: true }
    )

    onMounted(() => {
      const { isNewStyle } = props
      formsList.value.forEach((item: FormInputBasic) => {
        const initialValue = props.initialModel
          ? props.initialModel[item.id]
          : false
        const value = initialValue || item.initialValue || null

        root.$set(model.value, item.id, value)
      })
      emit('change', model.value)
    })

    // Добавляет звездочку к строке если поле required
    const getLabel = (label = '', rules = []) => {
      const arr = [].concat(rules)
      arr.forEach((rule, id) => {
        if (typeof rule === 'function') {
          arr.splice(id, 1)
          arr.push(rule(model.value, ...props.parentsModel))
        }
      })
      if (!label) {
        return ''
      }
      return Array.isArray(arr) && arr.includes('required')
        ? label + '<span class="red-text">*</span>'
        : label
    }
    const getMask = (mask) => {
      if (typeof mask === 'function') {
        return mask(model.value, ...props.parentsModel)
      }
      return mask
    }

    const onBlur = (name, index) => {
      const field = formsList.value.find(
        (form: FormInputBasic) => form.id === name
      )
      if (
        validateOnBlurInputFieldTypes.includes(field.field) &&
        props.useValidateOnBlur
      ) {
        checkItemErrors(field, index)
        showError.value = true
      }
    }

    return {
      onChange,
      // verifyToken,
      // verifyCaptcha,
      // expiredCaptcha,
      isInvalidForm,
      showError,
      errors,
      textErrors,
      model,
      checkErrors,
      submitPrevent,
      setTel,
      tel,
      getLabel,
      validationCounter,
      getMask,
      blockShowif,
      clear,
      btnText,
      switchLinkText,
      switchLink,
      onBlur,
      showCaptcha,
      formsList,
    }
  },
})
